import { NgModule } from '@angular/core';
import { FreelancerCurrencyPipe } from './currency/currency.pipe';
import { DateRangePipe } from './date-range.pipe';
import { DurationPipe } from './duration.pipe';
import { FileSizePipe } from './file-size.pipe';
import { IsOnlinePipe } from './is-online.pipe';
import { PascalCasePipe } from './pascal-case/pascal-case.pipe';
import { SanitisePipe } from './sanitise.pipe';
@NgModule({
  declarations: [
    FileSizePipe,
    FreelancerCurrencyPipe,
    DateRangePipe,
    DurationPipe,
    IsOnlinePipe,
    PascalCasePipe,
    SanitisePipe,
  ],
  exports: [
    FileSizePipe,
    FreelancerCurrencyPipe,
    DateRangePipe,
    DurationPipe,
    IsOnlinePipe,
    PascalCasePipe,
    SanitisePipe,
  ],
  providers: [
    FileSizePipe,
    FreelancerCurrencyPipe,
    DurationPipe,
    IsOnlinePipe,
    PascalCasePipe,
    SanitisePipe,
  ],
})
export class PipesModule {}
